<div class="modal-small">
    <h4>Rename the Data Series</h4>
    <div class="mt-24">
        <label for="input_rename" class="d-flex body-1 mb-8">Enter the name</label>
        <div class="input-block mb-8">
            <input [(ngModel)]="name" class="text-field" type="text">
        </div>
    </div>
    <div class="mt-24">
        <button (click)="save()" class="btn btn-primary mr-16">Save</button>
        <button mat-dialog-close class="btn btn-secondary">Cancel</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
